module.exports = __webpack_public_path__ + "img/dd5.aa607c21.jpg";